import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import orSpinner from "../../../HOCs/orSpinner";

const IconOrSpinner = orSpinner(FontAwesomeIcon);

export default IconOrSpinner;
